import { CreateOrderRequest } from '@models/order';
import { openDB } from 'idb';

const DB_NAME = 'order';
const STORE_NAME = 'tempOrder';
const ID_KEY = 'id';
const ID_VALUE = 'app';

async function getDB() {
    return openDB(DB_NAME, 1, {
        upgrade(db) {
            db.createObjectStore(STORE_NAME, { keyPath: ID_KEY });
        },
    });
}

export async function saveTempOrder(request: CreateOrderRequest) {
    const db = await getDB();
    await db.put(STORE_NAME, {
        ...request, id: ID_VALUE,
    });
}

export async function getTempOrder(): Promise<CreateOrderRequest|undefined> {
    const db = await getDB();
    try {
        const row = await db.get(STORE_NAME, ID_VALUE);
        console.log({ row });
        if (typeof row === 'object') {
            return row as CreateOrderRequest;
        }
        return undefined;
    } catch {
        return undefined;
    }
}

export async function deleteTempOrder() {
    const db = await getDB();
    await db.delete(STORE_NAME, ID_VALUE);
}
